module.exports = __webpack_public_path__ + "static/psui-207a086c5c81dfe73950de14108be257.png";